let frame = 0
let canvas = null
let context = null
let onScroll = null

export function particleCount() {
  if (window.matchMedia("(max-width: 767px)").matches) return 80
  if (window.matchMedia("(max-width: 1199px)").matches) return 140
  return 180
}

function reducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}

// Mockup §18: background 0.10x, middle 0.20x, foreground 0.05x in reverse.
export function applyParallax(root, y) {
  const mobile = window.matchMedia("(max-width: 767px)").matches
  const still = !root || reducedMotion() || mobile

  if (still) {
    setLayers(root, 0, 0, 0)
    setRune(0)
    return
  }

  const k = window.matchMedia("(max-width: 1199px)").matches ? 0.5 : 1
  setLayers(root, y * 0.1 * k, y * 0.2 * k, y * -0.05 * k)
  setRune(y * 0.06 * k)
}

function setLayers(root, sky, mid, fore) {
  if (!root) return
  root.style.setProperty("--parallax-sky", `${sky}px`)
  root.style.setProperty("--parallax-mid", `${mid}px`)
  root.style.setProperty("--parallax-fore", `${fore}px`)
}

function setRune(offset) {
  document.querySelectorAll("[data-parallax-rune]").forEach((rune) => {
    rune.style.setProperty("--parallax-rune", `${offset}px`)
  })
}

export function startWeather() {
  stopWeather()
  const root = document.querySelector("[data-weather-root]")
  if (!root) return { started: false }

  onScroll = () => applyParallax(root, window.scrollY)
  window.addEventListener("scroll", onScroll, { passive: true })
  onScroll()

  if (reducedMotion()) return { started: false }

  canvas = root.querySelector("[data-snow]")
  if (!canvas) return { started: false }
  canvas.hidden = false
  context = canvas.getContext("2d")
  const flakes = Array.from({ length: particleCount() }, () => ({
    x: Math.random(),
    y: Math.random(),
    r: Math.random() * 1.4 + 0.3,
    drift: Math.random() * 0.0006 - 0.0003,
    speed: Math.random() * 0.0018 + 0.0006
  }))

  const tick = () => {
    if (!canvas) return
    canvas.width = root.clientWidth
    canvas.height = root.clientHeight
    context.clearRect(0, 0, canvas.width, canvas.height)
    context.fillStyle = "rgba(241, 245, 246, 0.65)"
    flakes.forEach((flake) => {
      flake.y += flake.speed
      flake.x += flake.drift
      if (flake.y > 1) flake.y = 0
      if (flake.x > 1) flake.x = 0
      if (flake.x < 0) flake.x = 1
      context.beginPath()
      context.arc(flake.x * canvas.width, flake.y * canvas.height, flake.r, 0, Math.PI * 2)
      context.fill()
    })
    frame = requestAnimationFrame(tick)
  }
  tick()
  return { started: true, stop: stopWeather }
}

export function stopWeather() {
  if (frame) cancelAnimationFrame(frame)
  frame = 0
  if (onScroll) window.removeEventListener("scroll", onScroll)
  onScroll = null
  if (canvas) canvas.hidden = true
  canvas = null
  context = null
}
